import React from "react";
import { ShootingsDTO } from "../../interfaces/ShootingsDTO";
import { formatTime } from "../../services/timeHandler";
import ShootingTarget from "../shooting/ShootingTarget";

interface Props {
  shooting: ShootingsDTO | null;
}

const BiosTableRowShooting = ({ shooting }: Props) => {
  return shooting === null ? (
    <></>
  ) : (
    <tr className="bios-shooting-row">
      <td className="bios-shooting-row-position">{shooting.ShootNr}</td>
      <td className="bios-shooting-row-time">{shooting.Target1 === null ? <>&nbsp;</> : formatTime( shooting.Target1.ShootRunTime,"T")}</td>
      <td className="bios-shooting-row-time">{shooting.Target2 === null ? <>&nbsp;</> : formatTime(shooting.Target2.ShootRunTime,"T")}</td>
      <td className="bios-shooting-row-time">{shooting.Target3 === null ? <>&nbsp;</> : formatTime(shooting.Target3.ShootRunTime,"T")}</td>
      <td className="bios-shooting-row-time">{shooting.Target4 === null ? <>&nbsp;</> : formatTime(shooting.Target4.ShootRunTime,"T")}</td>
      <td className="bios-shooting-row-time">{shooting.Target5 === null ? <>&nbsp;</> : formatTime(shooting.Target5.ShootRunTime,"T")}</td>
      <td className="bios-shooting-row-time">{shooting.ShooTime === undefined ? <>&nbsp;</> : formatTime(shooting.ShooTime,"T")}</td>
      <td className="bios-shooting-row-target"><ShootingTarget lanenumber={null} shootingstring={shooting.ShootString === undefined ? "00000" : shooting.ShootString } miss={false} /></td>
    </tr>
  );
};

export default BiosTableRowShooting;
